export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8006.7e1ab5ec.jpg";